import { Injectable } from '@angular/core';
import { AbcCore } from '@barthauer/abc/core';
import { ProfileInfo, ProfileService } from '@barthauer/abc/core/authentication';
import { DataService, ExecuteQueryDocumentDef, QueryValueModel } from '@barthauer/abc/core/data';
import { ParameterValue } from '@barthauer/abc/queries/parameters/core';
import { ProfileInfoWithArenaViewModel } from 'libs/basys/map-frame/src/lib/viewModels/mapsData.viewModel';
import { Observable, of } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';

export interface DmlDocument {
  id: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class DMLService {
  predefinedDMLDocuments: DmlDocument[] = [
    { name: 'Abwasser', id: 'f8db7f07-a70e-4921-86c3-6b982f4268d9' },
    { name: 'Wasser', id: 'b6f8968d-3a96-43ed-a333-e54c20102142' },
    { name: 'Gas', id: 'fdc6c47c-f8e1-4dec-a037-1dab88f532dc' },
    { name: 'Kabel', id: '1cfb38d4-5422-4639-adc6-2bf7c8721f55' },
    { name: 'Strasse', id: 'CC8260BB-2604-459E-8052-68B9DB7180A3' },
  ];

  constructor(
    private coreDataService: DataService,
    private abcCore: AbcCore,
    private profileService: ProfileService
  ) {}

  queryObjectTypeNames(documentId: string) {}
  onObjectTypeNamesQueried(): Observable<string[]> {
    throw new Error('to be implemented!');
  }

  getDocumentIdByName(documentName: string): string {
    let docId: string = '';
    const idx = this.predefinedDMLDocuments.findIndex((d) => d.name === documentName);
    if (idx > -1) docId = this.predefinedDMLDocuments[idx].id;

    return docId;
  }

  executeDMLCore(documentId: string, parameters: ParameterValue[] = []): Observable<{ [key: string]: unknown[] }> {
    const executeQueryDocumentDef: ExecuteQueryDocumentDef = new ExecuteQueryDocumentDef();
    executeQueryDocumentDef.Id = documentId;
    if (parameters !== undefined && parameters.length > 0) executeQueryDocumentDef.Parameters = parameters;

    return this.coreDataService
      .executeQueryDocument(executeQueryDocumentDef)
      .pipe(map((_) => <{ [key: string]: unknown[] }>_));
  }

  isUsingStrang(): Observable<boolean> {
    const query = new QueryValueModel();
    query.OPath = "Type(Gemeinde)[Id=$CurrentMunicipalityId].Properties[Designation='StrangVerwenden'].TextValue";
    return this.coreDataService.executeReadValueQuery(query).pipe(
      map((data) => data as any as string),
      map((propValue) => {
        if (propValue) return propValue.toLowerCase() === 'true';
        else return false;
      })
    );
  }

  getPredefinedDMLQueriesFromCurrentProfile(): Observable<{ allowCustomDocuments: boolean; documents: DmlDocument[] }> {
    return this.profileService
      .getCurrentProfile(true)
      .pipe(concatMap((profileInfo) => this.getProfileView(profileInfo)))
      .pipe(concatMap((profileView) => this.prepareQueryDocuments(profileView)));
  }

  prepareQueryDocuments(
    profileView: ProfileInfoWithArenaViewModel
  ): Observable<{ allowCustomDocuments: boolean; documents: DmlDocument[] }> {
    return of(profileView?.settings?.findCommandDocuments('OperaManager_ImportObjects', 'Query'));
  }

  getProfileView(profileInfo: ProfileInfo): Observable<ProfileInfoWithArenaViewModel> {
    const ret = new ProfileInfoWithArenaViewModel(profileInfo, this.abcCore.objectSpace);
    return of(ret);
  }
}
